import request from '@/assets/js/utils/request'

export function create(data){
  return request({
    url: 'AppClient/FaultRepair/Create',
    method: 'post',
    data
  })
}

export function userList(data){
  return request({
    url: 'AppClient/FaultRepair/UserList',
    method: 'post',
    data
  })
}

export function managerList(data){
  return request({
    url: 'AppClient/FaultRepair/ManagerList',
    method: 'post',
    data
  })
}

export function getConfig(){
  return request({
    url: 'AppClient/FaultRepair/Config',
    method: 'post'
  })
}

export function getModel(data){
  return request({
    url: 'AppClient/FaultRepair/GetModel',
    method: 'post',
    data
  })
}

export function assign(data){
  return request({
    url: 'AppClient/FaultRepair/Assign',
    method: 'post',
    data
  })
}
export function evaluation(data){
  return request({
    url: 'AppClient/FaultRepair/Evaluation',
    method: 'post',
    data
  })
}
export function comment(data){
  return request({
    url: 'AppClient/FaultRepair/Comment',
    method: 'post',
    data
  })
}


export function workerList(){
  return request({
    url: 'AppClient/FaultRepair/WorkerList',
    method: 'post',
  })
}

export function typeList(){
  return request({
    url: 'AppClient/FaultRepair/TypeList',
    method: 'post',
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api/faultRepair.js